import { IEntityPickerFetcher } from './entityPickerFetcher';
import { IEpickNode } from './EpickTree';
import { ITreeNode } from 'components/Tree/CommonTree/CommonTreeNode';
import { DecisionsTypePickerSettings } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/DecisionsTypePickerSettings';
import { IEntityPickerTreeModel } from './defaultEpickTreeModel';
import { decisionsTypeTreeModel, splitNameAndType } from './decisionsTypeTreeModel';

export function inputDesignerEpickTreeModel(
  settings: DecisionsTypePickerSettings,
  dataFetcher: IEntityPickerFetcher
): IEntityPickerTreeModel {
  const base = decisionsTypeTreeModel(settings, dataFetcher);

  const getSubNodes = async (nodeId: string): Promise<ITreeNode<IEpickNode>[]> => {
    const nodes = await base.getSubNodes(nodeId);
    return nodes.map(node => {
      node.description = undefined;
      if (node.data?.pickable) {
        let nameValue = splitNameAndType(node.data.name)[0];
        node.data.name = nameValue;
        // for Data Designer Toolbox nodes are drag-dropable
        node.data.pickable = false;
      }
      return node;
    });
  };

  const getRootNodes = async () => {
    const nodes = await base.getRootNodes();
    return nodes.map(node => {
      node.description = undefined;
      return node;
    });
  };

  return { ...base, getSubNodes, getRootNodes };
}
